import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type { CatalogCertificatesListResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

type CatalogCertificatesListProps = {
  url: string;
  filters?: { archived?: boolean };
};

export const catalogCertificateKeys = {
  all: () => ['catalogCertificates'] as const,
  list: (props: CatalogCertificatesListProps) =>
    [
      ...catalogCertificateKeys.all(),
      'list',
      props.url,
      props.filters,
    ] as const,
};

export const catalogCertificateQueries = {
  list: (props: CatalogCertificatesListProps) =>
    queryOptions({
      queryKey: catalogCertificateKeys.list(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<CatalogCertificatesListResponseData>({
              method: 'GET',
              url: props.url,
              params: props.filters ? { filters: props.filters } : undefined,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
